import React from "react";
// import { Card } from "react-bootstrap";
import { Card, Stack } from "@mui/material";
import status from "./status.json";
import Tooltip from "@mui/material/Tooltip";
import "./Status.css";
import quetion from "../../Media/img/quetion.svg";
import { getstatuses } from "../../utils/Token";
import SelectYetQues from "../../icons/VendorStatusIcons/Yet to select Questionnire.svg";
import { styled } from "@mui/material";

export default function StatusComponent(props) {
  const value = status.find((r) => r.value === props.type);
  const title = getstatuses()?.find((r) => r?.prequalificationStatusId === props.type);

  const PQS = status.find((r) => r.key == props.typeStatus);
  const Title = getstatuses()?.find((r) => r?.prequalificationStatus == props.typeStatus);
  // console.log(props.typeStatus);
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <>
      {props?.ChangePq == true ?
        <>
          <Tooltip title={Title?.prequalificationDescription} placement="right" arrow>
            <Card
              style={{
                backgroundColor: PQS?.color,
                color: PQS?.value == 34 || PQS?.value == 10 ? "#000" : "#fff",
                width: "fit-content",
                textAlign: "center",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              <Stack direction="row">
                <span className="container">
                  {[1, 2, 6, 11].includes(PQS?.value) ? <img src={SelectYetQues} alt={PQS?.key} /> : <img src={PQS?.imageUri} alt={Title?.prequalificationStatus} />} &nbsp; <span>{[1, 2, 6, 11].includes(PQS?.value) ? PQS?.key : Title?.prequalificationStatus}</span>
                </span>
                <img className="sub" hidden={props?.RemoveDescription} src={quetion} alt={Title?.prequalificationStatus} />
              </Stack>
            </Card>
          </Tooltip>
        </>
        : <>
          <Tooltip title={props?.RemoveDescription == true ? "" : title?.prequalificationDescription} placement="right" arrow>
            <Card
              style={{
                backgroundColor: value?.color,
                color: value?.value == 34 || value?.value == 10 ? "#000" : "#fff",
                width: "fit-content",
                textAlign: "center",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              <Stack direction="row">
                <span className="container">
                  {[1, 2, 6, 11].includes(props.type) ? <img src={SelectYetQues} alt={value?.key} /> : <img src={value?.imageUri} alt={title?.prequalificationStatus} />} &nbsp; <span>{[1, 2, 6, 11].includes(props.type) ? value?.key : title?.prequalificationStatus}</span>
                </span>
                <img className="sub" hidden={props?.RemoveDescription} src={quetion} alt={title?.prequalificationStatus} />
              </Stack>
            </Card>
          </Tooltip>
        </>
      }
    </>
  );
}
